import { FC } from 'react';

/** @deprecated */
const CogInHomeIcon: FC = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 12V23H21V11.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 11.5L12.5 1L24 11.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.5 2H20V5.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.5,14.5a2,2 0 1,0 4,0a2,2 0 1,0 -4,0" stroke="black" />
    <path
      d="M9.45522 11.813C8.9303 10.5181 10.7074 9.49207 11.5664 10.5941V10.5941C12.0489 11.2132 13.0035 11.2028 13.4997 10.5731V10.5731C14.3832 9.45216 16.1381 10.4398 15.5846 11.7464V11.7464C15.2737 12.4804 15.742 13.2916 16.5331 13.3893V13.3893C17.9414 13.5633 17.9193 15.5769 16.5068 15.7815V15.7815C15.7134 15.8964 15.2271 16.718 15.5219 17.4454V17.4454C16.0468 18.7403 14.2697 19.7663 13.4108 18.6642V18.6642C12.9283 18.0452 11.9736 18.0555 11.4774 18.6852V18.6852C10.594 19.8062 8.83903 18.8185 9.39255 17.5119V17.5119C9.70349 16.7779 9.23514 15.9667 8.44404 15.869V15.869C7.03571 15.6951 7.05785 13.6814 8.47034 13.4769V13.4769C9.26378 13.3619 9.75008 12.5404 9.45522 11.813V11.813Z"
      stroke="black"
    />
  </svg>
);

export default CogInHomeIcon;
